import type { JSX } from 'react';

import { Pill } from '../Pill';

export type AdminStatusValue =
  | 'ok'
  | 'warming'
  | 'draining'
  | 'up'
  | 'degraded'
  | 'down';

type StatusConfig = {
  label: string;
  tone: 'success' | 'warning' | 'default' | 'danger';
  dotClass: string;
  pillClassName?: string;
};

const STATUS_CONFIG: Record<AdminStatusValue, StatusConfig> = {
  ok: {
    label: 'Ready',
    tone: 'success',
    dotClass: 'bg-emerald-500',
  },
  warming: {
    label: 'Warming',
    tone: 'warning',
    dotClass: 'bg-amber-500',
  },
  draining: {
    label: 'Draining',
    tone: 'default',
    dotClass: 'bg-zinc-400',
  },
  up: {
    label: 'Up',
    tone: 'success',
    dotClass: 'bg-emerald-500',
  },
  degraded: {
    label: 'Degraded',
    tone: 'warning',
    dotClass: 'bg-amber-500',
  },
  down: {
    label: 'Down',
    tone: 'danger',
    dotClass: 'bg-red-500',
    pillClassName:
      'bg-red-100 text-red-700 dark:bg-[color-mix(in_srgb,var(--color-red-900)_40%,transparent)] dark:text-red-300',
  },
};

export function AdminStatusPill({
  status,
  dot = false,
}: {
  status: AdminStatusValue;
  dot?: boolean;
}): JSX.Element {
  const { label, tone, dotClass, pillClassName } = STATUS_CONFIG[status];
  return (
    <Pill tone={tone} className={pillClassName}>
      {dot ? (
        <span
          aria-hidden
          className={`mr-1.5 inline-block h-2 w-2 rounded-full ${dotClass}`}
        />
      ) : null}
      {label}
    </Pill>
  );
}
